import VerifiedLeadsRows from "./VerifiedLeadsRows.tsx";
import { RootState, useAppSelector } from "../../../../../state/state.tsx";
import { useEffect, useRef, useState } from "react";
import { BusinessLeadsType } from "../../../types/CampaignsTypes.ts";
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import { MenuItem, TextField } from "@mui/material";

import { Timestamp } from 'firebase/firestore'; // Make sure to import Timestamp
const settings = {
    width: 110,
    height: 110,
  };

  const chartColors = {
    processed: '#ffb627', 
    sent: '#31CB00',      
    delivered: '0353A4',
    converted: '#ff5400', 
    failed: '#DD0426'     
};

export default function VerifiedLeads() {

    let pastCampaigns = useAppSelector((state: RootState) => state.PastCampaignSlice.data)

   
    const [selectedCampaignIndex, setSelectedCampaignIndex] = useState<number >(-1)


    // Filter
    type filters = {
        Interested: boolean,
        NotInterested: boolean,
    }

    // State to manage dropdown visibility
    const [isDropdownVisible, setDropdownVisible] = useState(false);

    const [LeadsFilters, setFilters] = useState<filters>({

        Interested: true,
        NotInterested: true,
    });

    // ALL VERIFIEDLEADS

    const verifiedLeads = useAppSelector((state: RootState) => state.BusinessLeadsSlice.data)
    const [filteredLeads, setFilteredLeads] = useState<BusinessLeadsType[]>([])


    useEffect(() => {
        const newFilteredLeads: any = []
        if (LeadsFilters.Interested) {
            verifiedLeads.forEach(lead => {
                if (lead.status === "Interested") {
                    newFilteredLeads.push(lead);
                }
            });

        }

        if (LeadsFilters.NotInterested) {
            verifiedLeads.forEach(lead => {
                if (lead.status === "Not Interested") {
                    newFilteredLeads.push(lead);
                }
            })
        }

        newFilteredLeads.sort((a, b) => {
            const timeA = new Date(a.shownInterestTime).getTime();
            const timeB = new Date(b.shownInterestTime).getTime();
            return timeB - timeA; // Descending order (recent to old)
        });
        setFilteredLeads(newFilteredLeads)

    }, [verifiedLeads, LeadsFilters]);


    // Ref to track the dropdown element
    const dropdownRefs: any = useRef(null);

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event: { target: any; }) => {

            if (dropdownRefs.current && !dropdownRefs.current.contains(event.target)) {
                setDropdownVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Handler for changing filter state
    const handleFilterChange = (filter: string) => {
        setFilters((prevFilters: any) => ({
            ...prevFilters,
            [filter]: !prevFilters[filter],
        }));
    };

    // Toggle dropdown visibility
    const toggleDropdowns = () => {
        setDropdownVisible(!isDropdownVisible);
    };

    // Count the number of selected filters
    const selectedCount = Object.values(LeadsFilters).filter(Boolean).length;

// Graph analytics
const [graphValues, setGraphValues] = useState({
    processed: { value: 0, percent: 0 },
    sent: { value: 0, percent: 0 },
    delivered: { value: 0, percent: 0 },
    converted: { value: 0, percent: 0 },
    failed: { value: 0, percent: 0 }
});

useEffect(() => {
    if (selectedCampaignIndex !== -1 && pastCampaigns[selectedCampaignIndex]) {
        const campaign = pastCampaigns[selectedCampaignIndex];
        const processed = campaign.processed || 0;
        const sent = campaign.sent || 0;
        const delivered = campaign.delivered || 0;
        const converted = campaign.interested || 0;
        const failed = campaign.failed || 0;

        setGraphValues({
            processed: {
                value: processed,
                percent: processed > 0 ? Math.round((processed / processed) * 100) : 0
            },
            sent: {
                value: sent,
                percent: sent > 0 ?  Math.round((sent / processed) * 100) : 0 // Always 100% if sent exists
            },
            delivered: {
                value: delivered,
                percent: processed > 0 ? Math.round((delivered / processed) * 100) : 0
            },
            converted: {
                value: converted,
                percent: processed > 0 ? Math.round((converted / processed) * 100) : 0
            },
            failed: {
                value: failed,
                percent: processed > 0 ? Math.round((failed / processed) * 100) : 0
            }
        });
    } else {
        setGraphValues({
            processed: { value: 0, percent: 0 },
            sent: { value: 0, percent: 0 },
            delivered: { value: 0, percent: 0 },
            converted: { value: 0, percent: 0 },
            failed: { value: 0, percent: 0 }
        });
    }
}, [selectedCampaignIndex, pastCampaigns]);





    return (
    <div className="">
    

        <div className="mb-4 ">
            <TextField
                size="small"
                id="SelectCampaign"
                select
                fullWidth={true}
                label="Select Campaign"
                value={selectedCampaignIndex}
                onChange={(e) => {
                    setSelectedCampaignIndex(Number(e.target.value))
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'grey', borderRadius: '10px'
                        },
                        '&:hover fieldset': {
                            borderColor: 'grey',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'skyblue',
                        },
                        '& .MuiInputBase-input': {
                            fontSize: '14px',
                        },
                    },
                    fontWeight: 400,
                    fontSize: "1px",
                }}
            >
                {pastCampaigns.map((campaign, index) => (
                    <MenuItem key={index} value={index}>
                        {`${campaign.template} on ${campaign.timestamp}`}
                    </MenuItem>
                ))}
                <MenuItem value={-1}>WhatsApp QR Code</MenuItem>
            </TextField>
        </div>


        <div  style={{
                    background: "linear-gradient(90deg, rgba(29,78,216,0.0145) 0%, rgba(29,78,216,0.1339) 44%, rgba(29,78,216,0.0313) 98%)",
                    // Fallback color if gradient isn't supported
                }} className="p-1.5 rounded-xl  mx-auto shadow-[0px_0px_4px_2px_rgba(0,0,0,0.1)]  mb-4">

            <div className="px-6 py-4">
                <p className={"text-black text-2xl font-semibold"}>Campaign Performance Overview</p>
                <p className="text-sm text-gray-600">
                    Track and analyze your campaign effectiveness with key performance indicators.
                </p>
            </div>
            <div className="px-6 flex relative gap-6 mb-2">
            <div className="processed flex relative flex-col items-center">
                <Gauge
                    {...settings}
                    value={graphValues.processed.percent}
                    cornerRadius="50%"
                    sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                            fontSize: 22,
                            fontWeight: 'bold',
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: chartColors.processed,
                        },
                        [`& .${gaugeClasses.referenceArc}`]: {
                            fill: '#adb5bd', // Light gray color
                        },
                        
                    })}
                    text={
                        `${graphValues.processed.percent}%`
                    }
                />
                <div className="text-center mt-2">
                    <p className="font-semibold text-cf_subHeading">{pastCampaigns[selectedCampaignIndex]?.processed?pastCampaigns[selectedCampaignIndex].processed:0}</p>
                    <p className=" text-black">Processed</p>
                </div>
            </div>
            <div className="sent flex  relative flex-col items-center">
                <Gauge
                    {...settings}
                    value={graphValues.sent.percent}
                    cornerRadius="50%"
                    sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                            fontSize: 22,
                            fontWeight: 'bold',
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: chartColors.sent,
                        },
                        [`& .${gaugeClasses.referenceArc}`]: {
                            fill: '#adb5bd', // Light gray color
                        },
                        
                    })}
                    text={
                        `${graphValues.sent.percent}%`
                     }
                />
                <div className="text-center mt-2">
                    <p className="font-semibold text-cf_subHeading">{graphValues.sent.value}</p>
                    <p className=" text-black">Sent</p>
                </div>
            </div>
            <div className="delivered flex relative flex-col items-center">
                <Gauge
                    {...settings}
                    value={graphValues.delivered.percent}
                    cornerRadius="50%"
                    sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                            fontSize: 22,
                            fontWeight: 'bold',
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: chartColors.delivered,
                        },
                        [`& .${gaugeClasses.referenceArc}`]: {
                            fill: '#adb5bd', // Light gray color
                        },
                        
                    })}
                    text={
                        `${graphValues.delivered.percent}%`
                     }
                />
                <div className="text-center mt-2">
                    <p className="font-semibold text-cf_subHeading">{graphValues.delivered.value}</p>
                    <p className=" text-black">Delivered</p>
                </div>
            </div>
            <div className="converted flex relative flex-col items-center">
                <Gauge
                    {...settings}
                    value={graphValues.converted.percent}
                    cornerRadius="50%"
                    sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                            fontSize: 22,
                            fontWeight: 'bold',
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: chartColors.converted,
                        },
                        [`& .${gaugeClasses.referenceArc}`]: {
                            fill: '#adb5bd', // Light gray color
                        },
                        
                    })}
                    text={
                        `${graphValues.converted.percent}%`
                     }
                />
                <div className="text-center mt-2">
                    <p className="font-semibold text-cf_subHeading">{graphValues.converted.value}</p>
                    <p className=" text-black">Converted</p>
                </div>
            </div>
            <div className="failed flex relative flex-col items-center">
                <Gauge
                    {...settings}
                    value={graphValues.failed.percent}
                    cornerRadius="50%"
                    sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                            fontSize: 22,
                            fontWeight: 'bold',
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: chartColors.failed,
                        },
                        [`& .${gaugeClasses.referenceArc}`]: {
                            fill: '#adb5bd', // Light gray color
                        }
                        
                    })}
                    text={
                        `${graphValues.failed.percent}%`
                     }
                />
                <div className="text-center mt-2">
                    <p className="font-semibold text-cf_subHeading">{graphValues.failed.value}</p>
                    <p className=" text-black">Failed</p>
                </div>
            </div>
            </div>
        </div>

        <div className=" rounded-xl  mx-auto shadow-[0px_0px_4px_2px_rgba(0,0,0,0.1)]">
            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle">
                        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden ">

                            <div
                                className="px-6 py-4 grid gap-3 md:flex md:justify-between md:items-center border-b border-gray-200">
                                <div>
                                    <p className={"text-black text-2xl font-semibold"}>Verified Leads</p>
                                    <p className="text-sm text-gray-600">
                                        Individuals who have expressed interest will be listed here.
                                    </p>
                                </div>

                                <div>
                                    <div className="relative  -left-12 inline-block" ref={dropdownRefs}>
                                        <button
                                            type="button"
                                            className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 "
                                            aria-haspopup="true"
                                            aria-expanded={isDropdownVisible}
                                            onClick={toggleDropdowns}
                                        >
                                            <svg
                                                className="flex-shrink-0 size-3.5"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M3 6h18" />
                                                <path d="M7 12h10" />
                                                <path d="M10 18h4" />
                                            </svg>
                                            Filter
                                            <span
                                                className="ps-2 w-4 text-xs font-semibold text-blue-600 border-s border-gray-200 ">
                                                {selectedCount}
                                            </span>
                                        </button>
                                        {isDropdownVisible && (
                                            <div
                                                className="absolute transition-[opacity,margin] duration opacity-100 block divide-y divide-gray-200 min-w-48 z-10 bg-white shadow-md rounded-lg mt-2 "
                                                aria-labelledby="hs-as-table-table-filter-dropdown"
                                            >
                                                <div className="divide-y divide-gray-200 ">

                                                    <label htmlFor="filter-published" className="flex py-2.5 px-3">
                                                        <input
                                                            type="checkbox"
                                                            className="shrink-0 mt-0.5 border-gray-300 rounded text-blue-600 focus:ring-blue-500 "
                                                            id="filter-published"
                                                            checked={LeadsFilters.Interested}
                                                            onChange={() => handleFilterChange('Interested')}
                                                        />
                                                        <span
                                                            className="ms-3 text-sm text-gray-800">Interested</span>
                                                    </label>
                                                    <label htmlFor="filter-pending" className="flex py-2.5 px-3">
                                                        <input
                                                            type="checkbox"
                                                            className="shrink-0 mt-0.5 border-gray-300 rounded text-blue-600 focus:ring-blue-500 "
                                                            id="filter-pending"
                                                            checked={LeadsFilters.NotInterested}
                                                            onChange={() => handleFilterChange('NotInterested')}
                                                        />
                                                        <span
                                                            className="ms-3 text-sm text-gray-800 ">Not Interested</span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <table className="min-w-full divide-y divide-gray-200 ">
                                <thead className="bg-gray-50">
                                    <tr>
                                        {/*<th scope="col" className="ps-6 py-3 text-start">*/}
                                        {/*    <label htmlFor="hs-at-with-checkboxes-main" className="flex">*/}
                                        {/*        <input type="checkbox"*/}
                                        {/*               className="shrink-0 border-gray-300 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"*/}
                                        {/*               id="hs-at-with-checkboxes-main"/>*/}
                                        {/*        <span className="sr-only">Checkbox</span>*/}
                                        {/*    </label>*/}
                                        {/*</th>*/}

                                        <th scope="col" className="px-6 w-32 py-3 text-start">
                                            <div className="flex items-center gap-x-2">
                                                <span
                                                    className="text-xs font-semibold uppercase tracking-wide text-gray-800">
                                                    campaign                                                </span>
                                            </div>
                                        </th>

                                        <th scope="col" className="ps-6  lg:ps-3 xl:ps-0 pe-6 py-3 text-start">
                                            <div className="flex items-center pl-6  gap-x-2">
                                                <span
                                                    className="text-xs font-semibold uppercase tracking-wide text-gray-800">
                                                    Name
                                                </span>
                                            </div>
                                        </th>

                                        <th scope="col" className="px-6 py-3 text-start">
                                            <div className="flex items-center gap-x-2">
                                                <span
                                                    className="text-xs font-semibold uppercase tracking-wide text-gray-800">
                                                    Phone Number
                                                </span>
                                            </div>
                                        </th>

                                        <th scope="col" className="px-6 py-3 text-start">
                                            <div className="flex items-center gap-x-2">
                                                <span
                                                    className="text-xs font-semibold uppercase tracking-wide text-gray-800">
                                                    Status
                                                </span>
                                            </div>
                                        </th>

                                        <th scope="col" className="px-6 w-32 py-3 text-start">
                                            <div className="flex items-center gap-x-2">
                                                <span
                                                    className="text-xs font-semibold uppercase tracking-wide text-gray-800">
                                                    Notes
                                                </span>
                                            </div>
                                        </th>

                                        <th scope="col" className="px-6 py-3 text-start">
                                            <div className="flex items-center gap-x-2">
                                                <span
                                                    className="text-xs font-semibold uppercase tracking-wide text-gray-800">
                                                    Interested time
                                                </span>
                                            </div>
                                        </th>

                                        <th scope="col" className="px-6 py-3 text-end"></th>
                                    </tr>
                                </thead>

                                <tbody
                                    className="divide-y divide-gray-200 max-h-[10px] overflow-scroll overflow-y-auto">


                                    {selectedCampaignIndex === -1 ? (
                                        filteredLeads
                                            .filter(lead => lead.campaignId==="WhatsAppQRCode")
                                            .map((data, index) => (
                                                <VerifiedLeadsRows verifiedLeadDoc={data} key={index} />
                                            ))
                                    ) : (
                                        filteredLeads
                                            .filter(lead => lead.campaignId === pastCampaigns[selectedCampaignIndex].id)
                                            .map((data, index) => (
                                                <VerifiedLeadsRows verifiedLeadDoc={data} key={index} />
                                            ))
                                    )}


                                </tbody>
                            </table>

                            <div
                                className="px-6 py-4 grid gap-3 md:flex md:justify-between md:items-center border-t border-gray-200 ">
                                <div>
                                    
                                </div>

                                <div>
                                    {/* <div className="inline-flex gap-x-2">
                                        <button type="button"
                                            className="py-1.5 px-2 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-50">
                                            <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg"
                                                width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <path d="m15 18-6-6 6-6" />
                                            </svg>
                                            Prev
                                        </button>

                                        <button type="button"
                                            className="py-1.5 px-2 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-50">
                                            Next
                                            <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg"
                                                width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round">
                                                <path d="m9 18 6-6-6-6" />
                                            </svg>
                                        </button>
                                    </div> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>)
}